import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "@phosphor-icons/react";
import StatusPill from "@/components/StatusPill";
import { fileUrl } from "@/lib/api";

export default function ProjectCard({ project, accent }) {
  const cover = fileUrl(project.cover_photo_id);
  return (
    <Link
      to={`/projects/${project.id}`}
      data-testid={`project-card-${project.id}`}
      className="block tactile-card btn-press p-4 hover:shadow-tactile-orange"
    >
      <div className="flex gap-3">
        {cover ? (
          <img
            src={cover}
            alt=""
            className="w-20 h-20 rounded-xl object-cover border-2 border-stone_border flex-shrink-0"
          />
        ) : (
          <div className="w-20 h-20 rounded-xl bg-kraft border-2 border-stone_border flex-shrink-0 flex items-center justify-center text-3xl font-heading text-timber-500">
            {project.title?.[0]?.toUpperCase() ?? "?"}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <StatusPill status={project.state || project.bucket} />
            {accent && <span className="label-cap text-masking">{accent}</span>}
          </div>
          <h3 className="font-heading font-bold text-timber-900 text-lg mt-1 truncate">
            {project.title}
          </h3>
          {project.location && (
            <p className="flex items-center gap-1 text-sm text-timber-700 mt-0.5">
              <MapPin size={14} /> {project.location}
            </p>
          )}
          {/* progress bar */}
          <div className="mt-2 flex items-center gap-2">
            <div className="flex-1 h-2 bg-kraft rounded-full overflow-hidden border border-stone_border">
              <div
                className="h-full bg-masking"
                style={{ width: `${project.progress_pct}%` }}
              />
            </div>
            <span className="text-xs font-mono text-timber-700">
              {project.steps_done}/{project.step_count}
            </span>
            <ArrowRight size={16} className="text-timber-500" />
          </div>
        </div>
      </div>
    </Link>
  );
}
